export default __webpack_public_path__ + "static/site-app-light-mode-0215bbb9337e8a0fe13b6b3f5f48d005.png";